import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Vacation } from '../beans/vacation';
import { HttpService } from './http.service';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class VacationService {

	private readonly baseUrl = environment.serviceBaseUrl + '/vacation';

	constructor(private http: HttpService) { }

	getMy(): Observable<Vacation[]> {
		return this.http.get<Vacation[]>(this.baseUrl + '/my');
	}

	getByDateRange(start: string, end: string): Observable<any[]> {
		return this.http.get<any[]>(this.baseUrl + '/byDateRange?start=' + start + '&end=' + end);
	}

	add(vacation: Vacation): Observable<Vacation> {
		return this.http.post<Vacation>(this.baseUrl + '/add', vacation);
	}

	update(vacation: Vacation): Observable<Vacation> {
		return this.http.post<Vacation>(this.baseUrl + '/update', vacation);
	}

	delete(id: number): Observable<any> {
		return this.http.post<any>(this.baseUrl + '/delete/' + id, {});
	}

	checkConflicts(startDate: string, endDate: string): Observable<any[]> {
		return this.http.post<any[]>(this.baseUrl + '/checkConflicts', { startDate, endDate });
	}
}
